import { render, staticRenderFns } from "./BookDailyPublicCategoryCard.vue?vue&type=template&id=1a8e6876&"
import script from "./BookDailyPublicCategoryCard.vue?vue&type=script&lang=ts&"
export * from "./BookDailyPublicCategoryCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports